import PropTypes from 'prop-types';
import React from 'react';

import { Col, FormGroup, Label } from 'twyne-new.ui';

const AuditResultBodyItem = ({ label, value, size = 2 }) => <Col size={size}>
  <FormGroup>
    <Label>{label}</Label>
    <span className='twy-text-base-accent break-words'>{value}</span>
  </FormGroup>
</Col>

AuditResultBodyItem.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  size: PropTypes.string,
};

AuditResultBodyItem.defaultProps = {
  size: '2',
}

export default AuditResultBodyItem;
